import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { throwError } from "rxjs";
import { Router } from "@angular/router";
import { NotificationService } from "../services/Notification/notification.service";
import { catchError } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private notification: NotificationService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const token = sessionStorage.getItem("token");

    const authReq = token
      ? req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        })
      : req;

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.notification.error("Session expired");
          sessionStorage.clear();
          this.router.navigateByUrl("superAuth/login");
        }
        return throwError(() => error);
      }),
    );
  }
}
